import { render, staticRenderFns } from "./CollectionsList.vue?vue&type=template&id=1cc87f6c&scoped=true"
import script from "./CollectionsList.vue?vue&type=script&lang=js"
export * from "./CollectionsList.vue?vue&type=script&lang=js"
import style0 from "./CollectionsList.vue?vue&type=style&index=0&id=1cc87f6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc87f6c",
  null
  
)

export default component.exports